export * from './mergeProps.js';